/**
 * A Receita Federal usa uma sequência de asteriscos como marcador de campo não informado —
 * `NOME FANTASIA: ********` no comprovante de CNPJ — e a BrasilAPI repassa isso literal.
 * Tratar como ausência de dado.
 *
 * Sem isso o marcador é autopreenchido no cadastro PJ e vai para o backend como sobrenome,
 * que é de onde sai o nome de exibição da conta PJ — o requerente aparece como `********`
 * no processo. APR-2902.
 *
 * Gêmeos: `aprova-frontend/webapp/src/app/shared/utils/` (tem também a variante de sufixo, para
 * nome legado já concatenado) e `shared/src/@backend/utils/` (preserva o valor original em vez
 * de sempre devolver string, por causa da semântica do PATCH). Ao mexer, conferir os outros.
 */
export function withoutReceitaEmptyMarker(value: unknown): string {
  // `String(...)`: a resposta da BrasilAPI é um cast sem validação em runtime, e um valor
  // não-string aqui estouraria `TypeError` dentro do `catch` do provider — a consulta INTEIRA
  // do CNPJ falharia por causa de um campo opcional.
  const trimmed = String(value ?? '').trim();

  return /^\*+$/.test(trimmed) ? '' : trimmed;
}
